import { Colors } from '../../themes/colors';

interface IArrowRightIconProps {
  color?: string;
  size?: number;
}

export const ArrowRightIcon = ({
  color = Colors.secondary_500,
  size = 24,
}: IArrowRightIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3499 3.95145C12.8185 3.48282 13.5783 3.48282 14.047 3.95145L21.247 11.1514C21.7156 11.6201 21.7156 12.3799 21.247 12.8485L14.047 20.0485C13.5783 20.5171 12.8185 20.5171 12.3499 20.0485C11.8813 19.5799 11.8813 18.8201 12.3499 18.3514L17.5014 13.2L3.59844 13.2C2.9357 13.2 2.39844 12.6627 2.39844 12C2.39844 11.3372 2.9357 10.8 3.59844 10.8H17.5014L12.3499 5.6485C11.8813 5.17987 11.8813 4.42008 12.3499 3.95145Z"
      fill={color}
    />
  </svg>
);
